// Centralized API Client Config for LMS Front-End

const isServer = typeof window === "undefined";

if (isServer && typeof process !== "undefined" && process.env) {
  process.env.NODE_TLS_REJECT_UNAUTHORIZED = "0";
}

// Base URL for the .NET API (configure in .env as VITE_API_URL)
export const API_BASE_URL = import.meta.env.VITE_API_URL || "http://localhost:5026/api";

// Helper to get auth header
export function getAuthHeaders(): Record<string, string> {
  if (isServer) return {};
  const realToken = localStorage.getItem("access_token") || localStorage.getItem("accessToken");
  if (realToken) {
    return {
      Authorization: `Bearer ${realToken}`,
      "Content-Type": "application/json",
    };
  }
  const sessionStr = localStorage.getItem("lms-mock-session");
  if (!sessionStr) return { "Content-Type": "application/json" };
  try {
    const session = JSON.parse(sessionStr);
    return {
      Authorization: `Bearer ${session.access_token}`,
      "Content-Type": "application/json",
    };
  } catch (e) {
    return { "Content-Type": "application/json" };
  }
}

// Check if we should call the real API
export const useRealApi = () => !!API_BASE_URL;

// Dummy apiClient to satisfy legacy imports during migration
export const apiClient = {
  from: (table: string) => {
    const chain = {
      select: () => chain,
      insert: () => chain,
      update: () => chain,
      delete: () => chain,
      eq: () => chain,
      in: () => chain,
      order: () => chain,
      limit: () => chain,
      single: async () => ({ data: null, error: new Error("Not implemented") }),
      maybeSingle: async () => ({ data: null, error: null }),
      then: (resolve: any) => resolve({ data: [], error: null }),
    };
    return chain;
  },
  auth: {
    getUser: async () => ({ data: { user: null }, error: null }),
    getSession: async () => ({ data: { session: null }, error: null }),
  },
  rpc: async () => ({ data: null, error: null }),
  storage: {
    from: () => ({
      upload: async () => ({ data: null, error: null }),
      getPublicUrl: () => ({ data: { publicUrl: "" } }),
      list: async () => ({ data: [], error: null }),
      remove: async () => ({ data: null, error: null }),
    }),
  },
  channel: () => ({
    on: () => ({ subscribe: () => {} }),
    unsubscribe: () => {},
  }),
  removeChannel: () => {},
};
